import React, { useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomAccordion from "../../components/CustomAccordion";
import CustomTable from "../../components/CustomTable";
import moment from "moment";
import { icons } from "../../assets/icons";
import CustomButton from "../../components/CustomButton";
import { apiUrls } from "../../utils/api/apiUrls";
import useApi from "../../hooks/useApi";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";
import DetailsCard from "../../components/DetailsCard";
import { useMediaQuery } from "react-responsive";
import EditApproveModal from "../../CustomEditApproveModal/EditApproveModal";
import { approvedAmountPassAccordingToLevel, getArrayOfSelectedStoresCode } from "../../../srcWeb/utils/helpers";
import { displayDateFormat, labelSplitFun } from "../../utils/helpers";
import RejectModal from "../../CustomRejectModal/RejectModal";
import { buildStandaloneDmsApprovePayload } from "../../../srcWeb/utils/dmsStandaloneListUtils";

const sanitizeActionComment = (comment) => {
  if (!comment) return "";
  const trimmed = String(comment).trim();
  if (!trimmed) return "";
  const lower = trimmed.toLowerCase();
  if (lower === "bulk send all - approved") return "Approved";
  if (lower === "bulk send all - rejected") return "Rejected";
  if (lower === "resubmitted after rework") return "";
  return comment;
};

const PettyCashDetails = () => {
  const isMobileSmall = useMediaQuery({ query: "(max-width: 336px)" });

  const { vid } = useParams();
  const { state } = useLocation();
  const { data = [], apiCall } = useApi();
  const navigate = useNavigate();
  const { data: data1, apiCall: apiCall1 } = useApi();
  const { selectedStores = {}, user = {}, storeDropdownState } = useAuth();
  const { storeCode = ""} = selectedStores?.storeDetails || {}
  const {
    L1 = { status: "NA" },
    L2 = { status: "NA" },
    Finance = { status: "NA" },
  } = state || {};

  /** Same idea as web VoucherDetails / PettyCashDetails: "(Store display name - storeCode)". */
  const pettyCashRequestIdSuffix = () => {
    let storeName = state?.storeName != null ? String(state.storeName).trim() : "";
    let storeCodeVal = state?.storeCode != null ? String(state.storeCode).trim() : "";

    if (!storeName && storeCodeVal && user?.userLabel === "L1") {
      let storeList = storeDropdownState;
      if (!storeList?.length) {
        try {
          storeList = JSON.parse(localStorage.getItem("storeList") || "[]");
        } catch {
          storeList = [];
        }
      }
      const hit = storeList?.find((s) => s?.storeCode === storeCodeVal);
      if (hit?.name) storeName = String(hit.name).trim();
    }

    if (!storeCodeVal) {
      const sc =
        selectedStores?.storeDetails?.storeCode ?? selectedStores?.[0]?.storeCode;
      if (sc != null && String(sc).trim() !== "" && String(sc).trim() !== "All") {
        storeCodeVal = String(sc).trim();
      }
    }
    if (!storeName) {
      const n = selectedStores?.storeDetails?.name ?? selectedStores?.[0]?.name;
      if (n != null && String(n).trim() !== "" && String(n).trim() !== "All") {
        storeName = String(n).trim();
      }
    }

    if (storeName && storeCodeVal) return `(${storeName} - ${storeCodeVal})`;
    if (storeCodeVal) return `(${storeCodeVal})`;
    if (storeName) return `(${storeName})`;
    return null;
  };

  const [activeAccordion, setActiveAccordion] = useState(null);
  const [isEditApproveVisible, setIsEditApproveVisible] = useState({
    isOpen: false,
    data: [],
  });
  const [isRejectVisible, setIsRejectVisible] = useState({
    isOpen: false,
    data: [],
  });

  const showStatus = (key) => {
    switch (key) {
      case "Pending":
        return "Pending";
        break;
      case "Approved":
        return "Approved";
        break;

      case "Rejected":
        return "Rejected";
        break;

      case "Partially Approved":
        return "Partially Approved";
        break;

      default:
        return "NA";
        break;
    }
  };

  const showStatusColor = (key) => {
    switch (key) {
      case "Pending":
        return "text-[var(--pendingYellow)]";
        break;
      case "Approved":
        return "text-[var(--successGreen)]";
        break;
      case "Rejected":
        return "text-[var(--textRed)]";
        break;

      case "Partially Approved":
        return "text-[var(--pendingYellow)]";
        break;

      case "NA":
        return "text-[var(--blackColor)]";
        break;

      default:
        return "text-[var(--blackColor)]";
        break;
    }
  };

  const Component = (value) => {
    // const requestAmount = value?.l1_amount_approved || value?.l2_amount_approved || value?.finance_amount_approved
    return (
      <div>
        <div className="h-[4rem] border-b-[1px] border-[var(--borderGray2)] flex items-center px-5">
          <div className="min-w-[20rem] font-size-small">Status:</div>
          <div className={`font-size-small ${showStatusColor(value?.status)}`}>
            {value?.status || "-"}
          </div>
        </div>
        <div className="h-[4rem] border-b-[1px] border-[var(--borderGray2)] flex items-center px-5">
          <div className="min-w-[20rem] font-size-small">
            Request Amount (₹):
          </div>
          <div className="font-size-small">
            {/* {value?.status === "Rejected"
              ? 0
              : value?.status === "Approved"
              ? state?.amount
              : "-"} */}
            {value?.requestAmount}
          </div>
        </div>
        <div className="h-[4rem] border-b-[1px] border-[var(--borderGray2)] flex items-center px-5">
          <div className="min-w-[20rem] font-size-small">
            {value?.status === "Rejected" ? 'Rejected Amount (₹)' : 'Approved Amount (₹):'}
          </div>
          <div className="font-size-small">
          {value?.status === "Rejected"
              ? value.rejectedAmount
              : Number(value.approvedAmount) !== undefined ?  Number(value.approvedAmount) : value.approvedAmount
              || "-"}
          </div>
        </div>
        <div className="h-[4rem] border-b-[1px] border-[var(--borderGray2)] flex items-center px-5">
          <div className="min-w-[20rem] font-size-small">Action Date:</div>
          <div className="font-size-small">{value?.actionDate || "-"}</div>
        </div>
        <div className="h-[4rem] border-b-[1px] border-[var(--borderGray2)] flex items-center px-5">
          <div className="min-w-[20rem] font-size-small">Action Comment:</div>
          <div className="font-size-small">
            {sanitizeActionComment(value?.actionComment) || "-"}
          </div>
        </div>
        <div className="h-[4rem] flex items-center px-5">
          <div className="min-w-[20rem] font-size-small">Action By:</div>
          <div className="font-size-small">{value?.actionBy || '-'}</div>
        </div>
      </div>
    );
  };

  const pendingRequestTableDataHandler = (start, end, storeC) => {
    // if(storeCode.length > 0){
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 13,
          endDate: moment(end || start)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: "",
          status: "PENDING",
          storeCodes: getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)
          // storeCodes: [storeC],
        },
        method: "post",
        processData: true,
        accessor: "documents",
      });
    // }
  };
 
  const ImprestRequestApi = (payload, status) => {
    apiCall1({
      url: apiUrls.dmsService.approveRequest,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        pendingRequestTableDataHandler(
          new Date(),
          new Date(),
          selectedStores?.storeDetails?.storeCode || ""
        );
        toast.success(status);
        setIsEditApproveVisible({ ...isEditApproveVisible, isOpen: false });
        navigate(-1);
      },
    });
  };

  const rejectRequestHandler = (id = "", comment = "") => {
    ImprestRequestApi(
      buildStandaloneDmsApprovePayload({
        approved: [],
        comment,
        rejected: id,
        saveDecisionOnly: false,
      }),
      "Rejected Request Successfully"
    );
  };

  const approveRequestHandler = (id) => {
    ImprestRequestApi(
      buildStandaloneDmsApprovePayload({
        approved: id,
        comment: "",
        rejected: [],
        saveDecisionOnly: false,
      }),
      "Approved Request Successfully"
    );
  };

  const approveRejectButtonStage = (key) => {
    let status = state[key]?.status || "";
    switch (status) {
      case "Rejected":
        return false;

      case "Approved":
        return false;

      case "Pending":
        return true;

      default:
        return false;
    }
  };

  console.log("pettyCash details number", state);
  const accordionItems = [
    {
      renderLeft: () => {
        return (
          <div className={`font-family-medium ${isMobileSmall ? 'text-[1.3rem]' : 'font-size-small'}`}>
            L1 - Area Manager
          </div>
        );
      },
      renderRight: () => {
        return (
          <div
            className={`font-family-medium ${isMobileSmall ? 'text-[1.3rem]' : 'font-size-small'} ${showStatusColor(
              L1?.status
            )}`}
          >
            <span>
              {showStatus(L1?.status) || "Pending"}{" "}
              {(L1?.status?.toLocaleLowerCase() === "pending") ? "" : "| " + (state?.l1_amount_approved || "")}
            </span>
          </div>
        );
      },
      Component: () => {
        return Component({
          ...L1,
          requestAmount:state?.amount,
          approvedAmount: state?.l1_amount_approved,
          rejectedAmount: state?.amount,
        });
      },
      isArrowEnable:
      (L1?.status?.toLocaleLowerCase() === "pending") || L1?.status === "NA" ? false : true,
    },
    {
      renderLeft: () => {
        return (
          <div className={`font-family-medium ${isMobileSmall ? 'text-[1.3rem]' : 'font-size-small'} `}>
            L2 - Regional Manager
          </div>
        );
      },
      renderRight: () => {
        return (
          <div
            className={`font-family-medium ${isMobileSmall ? 'text-[1.3rem]' : 'font-size-small'} ${showStatusColor(
              L2?.status
            )}`}
          >
            <span>
            {showStatus(L2?.status) || "Pending"}{" "}
              {(L2?.status.toLocaleLowerCase() === "pending" || L2?.status === "NA")
                ? ""
                : "| " + (state?.l2_amount_approved || "")}
            </span>
          </div>
        );
      },
      Component: () => {
        return Component({
          ...L2,
          requestAmount: state?.amount,
          approvedAmount: state?.l2_amount_approved,
          rejectedAmount: state?.amount,        
        });
      },
      isArrowEnable:
      ( L2.status?.toLocaleLowerCase() === "pending" || L2?.status === "NA") ? false : true,

    },
    {
      renderLeft: () => {
        return (
          <div className={` font-family-medium ${isMobileSmall ? 'text-[1.3rem]' : 'font-size-small'}`}>
            L3 - Accounts Manager
          </div>
        );
      },
      renderRight: () => {
        return (
          <div
            className={`font-family-medium ${isMobileSmall ? 'text-[1.3rem]' : 'font-size-small'} ${showStatusColor(
              Finance?.status
            )}`}
          >
            <span>
            {showStatus(Finance?.status) || "Pending"}{" "}
              {(Finance?.status.toLocaleLowerCase() === "pending" || Finance?.status === "NA")
                ? ""
                : "| " + (state?.finance_amount_approved || "")}
            </span>
          </div>
        );
      },
      Component: () => {
        return Component({
          ...Finance,
          requestAmount: state?.amount,
          approvedAmount: state?.finance_amount_approved,
          rejectedAmount: state?.amount,
        });
      },
      isArrowEnable:
        Finance?.status?.toLocaleLowerCase() === "pending" || Finance?.status === "NA"
          ? false
          : true,
    },
  ];

  const columns = [
    {
      Header: "Submit On",
      accessor: "date",
      Cell: (rowData) => {
        return <div>{moment(rowData?.date).format(displayDateFormat)}</div>;
      },
    },
    {
      Header: "Description",
      accessor: "description",
      Cell: (rowData) => {
        return (
          <div>
            {rowData?.description}
          </div>
        );
      },
    },
    {
      Header: "Request Amount (₹)",
      accessor: "amount",
      Cell: (rowData) => {
        const value = rowData?.amount;
        let amount;
        if(typeof value == "string"){
          amount = Number(value).toFixed(2);
        } else {
          amount = value
        }
        return amount || "-";
      },
    },
    // {
    //   Header: "",
    //   accessor: "action",
    //   Cell: () => {
    //     return (
    //       <img
    //         alt="edit icon"
    //         src={icons.editIcon}
    //         className="w-[2.4rem] h-[2.4rem]"
    //       />
    //     );
    //   },
    // },
  ];

  const requestLabelColor = (request) => {
    let color = "text-[var(--successGreen)]"
    if(request.length > 0){
      let key = request.slice(request.length - 3);
      switch (key) {
        case "ted":
          color = 'text-[var(--textRed)]'
          break;
        case "ved":
          color = 'text-[var(--successGreen)]'
          break;
        case "ing":
          color = 'text-[var(--pendingYellow)]'
          break;
      
        default:
          color = "text-[var(--successGreen)]"
          break;
      }
    }
    return color;
  }

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        showBack
        renderLeft={() => {
          const idSuffix = pettyCashRequestIdSuffix();
          return (
            <div className={`flex items-center ${isMobileSmall ? 'text-[2rem]' : 'text-[3rem]'} font-family-medium`}>
              <div className="text-[var(--blackColor)]">
                Request ID: {vid}
                {idSuffix ? ` ${idSuffix}` : ""}
              </div>
            </div>
          );
        }}
      />

      <div className={`ml-16 mb-6 ${isMobileSmall ? 'text-[2rem]' : 'text-[3rem]'}`}>
        {state?.approval_status && (
          <div className={requestLabelColor(state.approval_status)}>
            {labelSplitFun(state?.approval_status) || ""}
          </div>
        )}
        <div className=" font-family-medium text-[var(--blackColor)]">
          Amount: ₹ {approvedAmountPassAccordingToLevel(state) || ""}
        </div>
      </div>

      <CustomAccordion
        items={accordionItems}
        activeIndex={activeAccordion}
        setActiveIndex={setActiveAccordion}
      />

      <DetailsCard
        data={state ? [state] : []}
        rows={columns}
        centerAlignedColumns={["r_amount"]}
        wrapperClassName="mt-4"
      />

      {approveRejectButtonStage(user?.userLabel || "") && (
        <div className={`mt-4 flex items-center justify-end gap-x-5`}>
          <CustomButton
            title="Edit"
            onClick={() => {
              const editedAmount = state?.finance_amount_approved ||
              state?.l2_amount_approved ||
                state?.l1_amount_approved ||
                state?.amount || 0;

              const ids = [
                { id: state?.parentId, approvedAmount: editedAmount, previousAm: editedAmount, totalAmount: editedAmount },
              ];
              setIsEditApproveVisible({
                data: ids,
                isOpen: true,
                previousAmounts: ids,
              });
            }}
            wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
          />
          <CustomButton
            title="Reject"
            onClick={() => {
              // let rejectIds =
              //   checkboxPropData.map((i) => i.original.parentId) || [];
              // rejectRequestHandler(state.parentId);
              setIsRejectVisible({ data: [state.parentId], isOpen: true })
              console.log("reject cash");
            }}
            wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
          />
          <CustomButton
            title="Approve"
            onClick={() => {
              const editedAmount = state?.finance_amount_approved ||
              state?.l2_amount_approved ||
                state?.l1_amount_approved ||
                state?.amount || 0;
              // let approvedIds =
              //   checkboxPropData.map((i) => i.original.parentId) || [];
              approveRequestHandler([{id: state?.parentId, approvedAmount: editedAmount || ""}]);
              console.log("approve cash");
            }}
            wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
          />
        </div>
      )}
      {isEditApproveVisible.isOpen && (
        <EditApproveModal
          isModalVisible={isEditApproveVisible}
          setIsModalVisible={setIsEditApproveVisible}
          approveHandler={({ data = [], comment = "" }) => {
            const validIds = [...new Set([...data])];
            approveRequestHandler(validIds, comment);
          }}
          ids={isEditApproveVisible?.previousAmounts}
          totalAmount={isEditApproveVisible?.previousAmounts?.[0]?.totalAmount}
        />
      )}
      {isRejectVisible.isOpen && (
        <RejectModal
          isModalVisible={isRejectVisible}
          setIsModalVisible={setIsRejectVisible}
          rejectHandler={({ data = [], comment = "" }) => {
            const validIds = [...new Set([...data])];
            rejectRequestHandler(validIds, comment);
          }}
        />
      )}
    </div>
  );
};

export default PettyCashDetails;
